import { useMemo } from 'react'

import { useChainId } from 'wagmi'

import { useAirdropChainId } from 'state/airdrop/hooks'

export function useIsWrongChainId() {
  const chainId = useChainId()
  const airdropChainId = useAirdropChainId()
  return useMemo(() => airdropChainId !== chainId, [airdropChainId, chainId])
}
